import React from 'react';
import { useT } from './BuilderApp.jsx';
import { ChevronLeft } from '../components/ui/Icons.jsx';
import LangSelect from '../components/ui/LangSelect.jsx';

export default function WizardShell({ step, total, children, onBack, title, subtitle, lang, setLang }) {
  const t = useT();
  const pct = Math.round((step / total) * 100);
  return (
    <div style={{minHeight:'100vh',display:'flex',flexDirection:'column',position:'relative',zIndex:1}}>
      <div style={{
        position:'sticky',top:0,zIndex:50,
        background:'rgba(5,10,20,.9)',
        backdropFilter:'blur(20px)',
        borderBottom:'1px solid var(--border)',
      }}>
        <div style={{display:'flex',alignItems:'center',gap:'1rem',padding:'.85rem 1.5rem'}}>
          <div style={{display:'flex',alignItems:'center',gap:'.5rem',flexShrink:0}}>
            <div style={{width:28,height:28,borderRadius:8,background:'linear-gradient(135deg,#2563eb,#7c3aed)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'.85rem'}}>⚡</div>
            <span style={{fontWeight:800,fontSize:'.9rem'}}>Chamcore</span>
          </div>
          <div style={{flex:1}}>
            <div className="progress-bar"><div className="progress-fill" style={{width:`${pct}%`}}/></div>
          </div>
          <div style={{display:'flex',alignItems:'center',gap:'.6rem',flexShrink:0}}>
            <span style={{fontSize:'.75rem',color:'var(--muted)'}}>{t.step_of(step, total)}</span>
            <LangSelect lang={lang} setLang={setLang}/>
          </div>
        </div>
      </div>
      <div style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',padding:'2.5rem 1.25rem 4rem'}}>
        <div style={{width:'100%',maxWidth:600}}>
          {onBack && (
            <button className="btn btn-ghost btn-sm" onClick={onBack} style={{marginBottom:'1.5rem',gap:'.3rem'}}>
              <ChevronLeft/> {t.back}
            </button>
          )}
          {title && (
            <div style={{marginBottom:'1.75rem'}}>
              <h2 style={{fontSize:'1.5rem',fontWeight:800,letterSpacing:'-.02em',marginBottom:'.3rem'}}>{title}</h2>
              {subtitle && <p style={{color:'var(--muted)',fontSize:'.88rem'}}>{subtitle}</p>}
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  );
}
